import { render, staticRenderFns } from "./serveUser.vue?vue&type=template&id=78d3b4a1&scoped=true&"
import script from "./serveUser.vue?vue&type=script&lang=js&"
export * from "./serveUser.vue?vue&type=script&lang=js&"
import style0 from "./serveUser.vue?vue&type=style&index=0&id=78d3b4a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d3b4a1",
  null
  
)

export default component.exports